<template>
  <tr class="word">
    <td>
      <div v-if="word.ja">
        <span class="word__ja">{{ word.ja }}</span>
        <TextSpeak :text="word.ja" lang="ja" />
      </div>
      <span v-if="word.ja_kana" class="word__ja-kana block">{{ word.ja_kana }}</span>

      <WordPreview :word="word" class="mt-2" />
    </td>

    <td class="space-y-1">
      <div v-if="word.category_layout_name === 'Computerese'">
        <div>
          <span class="word__en">{{ word.preview }}</span>
          <TextSpeak :text="word.preview" lang="en" />
        </div>
        <div v-if="word.en">
          <span class="">{{ word.en }}</span>
          <TextSpeak :text="word.en" lang="en" />
        </div>
      </div>

      <div v-else>
        <div v-if="word.en">
          <span class="word__en">{{ word.en }}</span>
          <TextSpeak :text="word.en" lang="en" />
        </div>
      </div>

      <div v-if="word.vi">
        <span class="word__vi">{{ word.vi }}</span>
        <TextSpeak :text="word.vi" lang="vi" />
      </div>
    </td>

    <td class="word__description">
      <div
        v-if="word.description_admin || word.description_vi"
        class="hidden lg:block"
        v-html="word.description_admin || word.description_vi"
      />
      <div v-if="word.description_admin || word.description_vi" class="text-sm w-12 block lg:hidden">
        <div class="link" @click="$emit('view-detail', word.id)">
          {{ $t('dictionary.detail') }}
        </div>
      </div>
    </td>
  </tr>
</template>

<script setup lang="ts">
  import TextSpeak from '&/TextSpeak.vue'
  import WordPreview from '&/WordPreview.vue'

  defineProps<{
    word: object
  }>()
</script>
